import { FC } from 'react';

import { Wrapper } from './styles';

export const Loading: FC = () => {
  return <Wrapper />;
};
